const React = require('react');
const toLower = require('mn-utils/toLower');
const trim = require('mn-utils/trim');
const isEmail = require('mn-utils/isEmail');
const onEnterProvider = require('mn-utils/onEnterProvider');
const {
  LINK_DASHBOARD,
  LINK_SIGN_IN,
  LINK_RECOVERY_TOKEN,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  Link,
  replaceLocation,
} = require('../../../../router');
const {
  decorateReconnect,
  apiAuthRecoveryToken,
} = require('../../../../api/_auth');
const {
  openPopupWindow,
} = require('../../../../emitters/popup');
const {
  login$,
  handleChangeEmail,
} = require('../../../../emitters/account');
const ButtonG = require('../../../dumb/Button/G');
const SendIcon = require('../../../icons/Send');
const Ripple = require('../../../dumb/Ripple');
const TextFieldI = require('../../../dumb/TextField/I');
const Base = require('./components/Base');

const forgotPassword = decorateReconnect(apiAuthRecoveryToken);


function openCheckYourEmail() {
  openPopupWindow((setPopupState, popup) => {
    popup.className = 'bg181A1C.95*2';

    return (stateOfPopup) => {
      return (
        <div className="rlv cF">
          <div className="mb30">
            <SendIcon className="w46 cF mhA"/>
          </div>
          <div className="mt30 f16 fw5 tc lh160%">
            We have sent your recovery token.<br/>
            Check your email!
          </div>
          <div className="mt40">
            <ButtonG
              className="w160 h48*2 mhA"
              onClick={popup.close}
            >OK</ButtonG>
          </div>
        </div>
      );
    };
  });
}


module.exports = withState((setState) => {
  let emailNode;

  function handleEmailRef(node) {
    node && (emailNode = node);
  }

  return (state) => {
    const {
      clicked,
    } = state;
    const email = state.email || '';
    const _email = trim(email);
    const invalidEmail = !isEmail(_email);

    function handleSubmit() {
      emailNode && emailNode.blur();
      if (invalidEmail) {
        setState({
          clicked: true,
        });
        return;
      }
      setState({
        loading: true,
      });
      const email = toLower(_email);
      forgotPassword({
        email,
      }).finally((error) => {
        error || (
          replaceLocation({
            path: LINK_RECOVERY_TOKEN,
          }),
          openCheckYourEmail()
        );
        setState({
          loading: false,
        });
      });
    }

    state.account && replaceLocation({
      path: LINK_DASHBOARD,
    });

    return (
      <Base
        title="Recovery password"
        description="We will send your recovery token to the specified email"
        content={(<>
          <TextFieldI
            className="mb30"
            value={email}
            error={clicked && invalidEmail}
            label="Email"
            helperText={
              _email
                ? 'This email is not valid'
                : 'Obligatory field'
            }
            onChange={handleChangeEmail}
            onKeyPress={onEnterProvider(handleSubmit)}
            inputRef={handleEmailRef}
          />
          <div className="ph25 pt15 pb35 lh18 lts0em">
            <Link
              href={LINK_SIGN_IN}
              className="c5B47FF olN tdU dn f12 fw3 o70:h"
            >I have a password</Link>
          </div>
        </>)}
        control={(
          <Ripple
            className="layoutRow fhaC fvaC wmin270 ph15
            h60 f16 lh21 r3 cF ttU tdN olN usN b0 dn bg5B47FF
            bg4B37EF:not[.disabled]:h o50.disabled"
            disabled={clicked && invalidEmail}
            onClick={handleSubmit}
          >Send recovery token</Ripple>
        )}
      />
    );
  };
}, {
  email: login$,
});
